/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';
import lodash from 'lodash';
import moment from 'moment';
import qs from 'qs';

// initial state
const state = {
  baseApiURL: '/api/sales/hearing-aids/flash',
  initialValues: null,
  contents: {
    name: '',
    business_id: 0,
    location_id: 0,
    totals: [],
    totalsByVendor: [],
    totalsByMonth: [],
    totalsByVendorByMonth: [],
    locations: [],
    businesses: [],
    mixVendor: [],
    mixTier: [],
    mixProducts: [],
    statsNational: [],
  },
  contentsTemplate: {
    name: '',
    business_id: 0,
    location_id: 0,
    totals: [],
    totalsByVendor: [],
    totalsByMonth: [],
    totalsByVendorByMonth: [],
    locations: [],
    businesses: [],
    mixVendor: [],
    mixTier: [],
    mixProducts: [],
    statsNational: [],
  },
  filters: {
    flashReportName: false,
    flashReport: {},
    vendor: [],
    tier: [],
    product: [],
    promo: [],
  },
  filtersTemplate: {
    flashReportName: false,
    flashReport: {},
    vendor: [],
    tier: [],
    product: [],
    promo: [],
  },
  filtersLists: {
    reportsList: [],
    disabledRange: null,
    productsList: [],
    vendorsList: [
      {
        label: 'Oticon',
        value: 'Oticon',
      },
      {
        label: 'Phonak',
        value: 'Phonak',
      },
      {
        label: 'Resound',
        value: 'Resound',
      },
      {
        label: 'Sonic',
        value: 'Sonic',
      },
      {
        label: 'Signia',
        value: 'Signia',
      },
      {
        label: 'Starkey',
        value: 'Starkey',
      },
      {
        label: 'Unitron',
        value: 'Unitron',
      },
      {
        label: 'Widex',
        value: 'Widex',
      },
    ],
    tiersList: [
      {
        label: 'Premium',
        value: 'Premium',
      },
      {
        label: 'Advanced',
        value: 'Advanced',
      },
      {
        label: 'Basic',
        value: 'Basic',
      },
      {
        label: 'Entry',
        value: 'Entry',
      },
      {
        label: 'Access',
        value: 'Access',
      },
      {
        label: 'CROS',
        value: 'CROS',
      },
      {
        label: 'OTC',
        value: 'OTC',
      },
    ],
    promosList: [
      {
        label: 'FUEL SEM',
        value: 'FUELSEM',
      },
    ],
  },
  dateFrom: null,
  dateTo: null,
  filtersListsTemplate: {
    reportsList: [],
    disabledRange: null,
    productsList: [],
    vendorsList: [
      {
        label: 'Oticon',
        value: 'Oticon',
      },
      {
        label: 'Phonak',
        value: 'Phonak',
      },
      {
        label: 'Resound',
        value: 'Resound',
      },
      {
        label: 'Sonic',
        value: 'Sonic',
      },
      {
        label: 'Signia',
        value: 'Signia',
      },
      {
        label: 'Starkey',
        value: 'Starkey',
      },
      {
        label: 'Unitron',
        value: 'Unitron',
      },
      {
        label: 'Widex',
        value: 'Widex',
      },
    ],
    tiersList: [
      {
        label: 'Premium',
        value: 'Premium',
      },
      {
        label: 'Advanced',
        value: 'Advanced',
      },
      {
        label: 'Basic',
        value: 'Basic',
      },
      {
        label: 'Entry',
        value: 'Entry',
      },
      {
        label: 'Access',
        value: 'Access',
      },
      {
        label: 'CROS',
        value: 'CROS',
      },
      {
        label: 'OTC',
        value: 'OTC',
      },
    ],
    promosList: [
      {
        label: 'FUEL SEM',
        value: 'FUELSEM',
      },
    ],
  },
  sectionsInReport: [],
  filtersChanged: true,
  loaders: {
    dashboardData: true,
    mixVendor: false,
    mixTier: false,
    filters: false,
    sections: false,
    totals: false,
    totalsByVendor: false,
    totalsByMonth: false,
    totalsByVendorByMonth: false,
    totalsByVendorByMonthOneRow: false,
    locations: false,
    businesses: false,
    statsNational: false,
  },
  initializers: {
    initialLoad: false,
    reportsList: false,
    initialCardLoaded: false,
  },
  // ...window.INITIAL_STATE.purchaseActivity,
};

// getters
const getters = {
  cancelToken: (state, getters, rootState) => rootState.main.cancelToken,
  baseApiURL: (state) => state.baseApiURL,
  initialValues: (state) => state.initialValues,
  contents: (state) => state.contents,
  dateFrom: (state) => state.dateFrom,
  dateTo: (state) => state.dateTo,
  filters: (state) => ({
    ...state.filters,
    // dateFrom: moment(state.dateFrom).format('YYYY-MM-01'),
    // dateTo: moment(state.dateTo).format('YYYY-MM-01'),
  }),
  promoFilter: (state) => state.filters.promo,
  sectionsInReport: (state) => state.sectionsInReport,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
  filtersLists: (state) => state.filtersLists,
  productsList: (state) => state.filtersLists.productsList,
  vendorsList: (state) => state.filtersLists.vendorsList,
  tiersList: (state) => state.filtersLists.tiersList,
  reportsList: (state) => state.filtersLists.reportsList,
  promosList: (state) => state.filtersLists.promosList,
  locations: (state) => state.contents.locations,
  businesses: (state) => state.contents.businesses,
  apiFilters: (state, getters) => ({
    // dateFrom: moment(getters.filters.dateFrom).format('YYYY-MM-01'),
    // dateTo: moment(getters.filters.dateTo).format('YYYY-MM-01'),
    filters: {
      ...state.filters,
      // vendor: getters.filters.vendor,
      // tier: getters.filters.tier,
      // product: getters.filters.product,
    },
  }),
  apiFilterString: (state, getters) => qs.stringify(getters.apiFilters, { arrayFormat: 'brackets' }),
  displayedSections: (state, getters) => lodash.filter(getters.sectionsInReport, (section) => getters[`display${section.replace(' ', '')}`]),
  displayTotals: (state) => !lodash.isEmpty(state.contents.totals),
  displayVendors: (state) => !lodash.isEmpty(state.contents.totalsByVendor),
  displayStats: (state) => !lodash.isEmpty(state.contents.statsNational),
  displayLocationSummary: (state) => (!lodash.isEmpty(state.contents.locations) && state.contents.locations.length > 1),
  displayLocations: (state) => (!lodash.isEmpty(state.contents.locations) && state.contents.locations.length > 1),
  displayPractices: (state) => (!lodash.isEmpty(state.contents.businesses) && state.contents.businesses.length > 1),
  loadingSections: (state) => lodash.chain([
    state.loaders.totals,
    state.loaders.vendors,
    state.loaders.statsNational,
    state.loaders.locations,
    state.loaders.businesses,
  ]).compact().value().length > 0,
  filtersChanged: (state) => state.filtersChanged,
  globalLoading: (state, getters, rootState) => rootState.main.globalLoading,
};

// actions
const actions = {
  async setPurchaseActivityCardDefaults({ commit, dispatch }) {
    commit('TOGGLE_INITIALIZED', { key: 'initialCardLoaded', value: false });
    await dispatch('getReports');
    commit('TOGGLE_INITIALIZED', { key: 'initialCardLoaded', value: true });
    commit('TOGGLE_LOADING', { key: 'dashboardData', value: false });
  },
  loadMixVendor({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'mixVendor', value: true });
    return axios.get(`/api/sales/hearing-aids/member/mixVendor/?${getters.apiFilterString}`)
      .then((response) => {
        commit('SET_CONTENTS', { key: 'mixVendor', value: lodash.sortBy(response.data, (vendor) => parseInt(vendor.units, 10)).reverse() });
        commit('TOGGLE_LOADING', { key: 'mixVendor', value: false });
      });
  },

  loadMixTier({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'mixTier', value: true });
    return axios.get(`/api/sales/hearing-aids/member/mixTier/?${getters.apiFilterString}`)
      .then((response) => {
        commit('SET_CONTENTS', { key: 'mixTier', value: lodash.sortBy(response.data, (tier) => parseInt(tier.units, 10)).reverse() });
        commit('TOGGLE_LOADING', { key: 'mixTier', value: false });
      });
  },

  purchaseActivityCardFiltersUpdated({ dispatch }) {
    dispatch('loadMixVendor');
    dispatch('loadMixTier');
  },

  /**
   *  Fetches a list of reports.
   */
  getReports({ commit, state, getters }) {
    return axios.get(`${state.baseApiURL}/filter/reports/`)
      .then((response) => {
        let reportsList = response.data.map(function(report) {
          let m = moment(report.year+'-'+report.month+'-01', 'YYYY-MM-DD')
          report.name = m.format('MMM. YYYY')+' '+report.work_days_current+'/'+report.work_days_total+' days';
          return report;
        }).slice(0,8);
        commit('SET_FILTER_LIST', { key: 'reportsList', value: reportsList });

        if (reportsList.length > 0) {
          commit('SET_FILTER_SIMPLE', { key: 'flashReportName', value: reportsList[0].name });
          commit('SET_FILTER_SIMPLE', { key: 'flashReport', value: reportsList[0] });
          commit('SET_PROPERTY', { key: 'filtersChanged', value: true });
        }

        commit('TOGGLE_INITIALIZED', { key: 'reportsList', value: true });
      }).catch((thrown) => {});
  },

  /**
   *  Get list of Products
   */
  getProducts({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'products', value: true });
    commit('SET_FILTER_LIST', { key: 'productsList', value: [] });
    return axios.get(`${state.baseApiURL}/filter/products/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token },)
      .then((response) => {
        commit('SET_FILTER_LIST', { key: 'productsList', value: response.data });
        commit('TOGGLE_LOADING', { key: 'products', value: false });
      }).catch((thrown) => {});
  },

  getData({ commit, dispatch }) {
    commit('TOGGLE_LOADING', { key: 'sections', value: true });
    commit('SET_PROPERTY', { key: 'filtersChanged', value: false });
    dispatch('getTotals');
    dispatch('getStatsNational');
    dispatch('getTotalsByVendor');
    dispatch('getLocations');
    dispatch('getPractices');
    commit('TOGGLE_INITIALIZED', { key: 'initialLoad', value: true });
  },

  getLocations({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'locations', value: true });
    return axios.get(`${state.baseApiURL}/member/locations/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        const data = response.data.map((locationTotals) => {
          // Create new Sales Store
          const locationData = {
            ...state.contentsTemplate,
            name: locationTotals.location_name,
            location_id: locationTotals.location_id,
          };

          // Unset that general data
          delete locationTotals.member_name;
          delete locationTotals.location_name;
          delete locationTotals.location_id;
          delete locationTotals.business_id;

          // Assign the remaining data to the totals for this location.
          locationData.totals = locationTotals;
          return locationData;
        });

        commit('SET_CONTENTS', { key: 'locations', value: data });
        commit('TOGGLE_LOADING', { key: 'locations', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  /**
   *
   */
  getPractices({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'businesses', value: true });
    return axios.get(`${state.baseApiURL}/member/members/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        const data = response.data.map((businessTotals) => {
          // Create new Sales Store
          const businessData = {
            ...state.contentsTemplate,
            name: businessTotals.member_name,
            business_id: businessTotals.business_id,
          };

          // Unset that general data
          delete businessTotals.member_name;
          delete businessTotals.business_id;

          // Assign the remaining data to the totals for this business.
          businessData.totals = businessTotals;
          return businessData;
        });
        commit('SET_CONTENTS', { key: 'businesses', value: data });
        commit('TOGGLE_LOADING', { key: 'businesses', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotals({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'totals', value: true });
    return axios.get(`${state.baseApiURL}/member/totals/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totals', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totals', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotalsByVendor({ commit, getters }) {
    commit('TOGGLE_LOADING', { key: 'totalsByVendor', value: true });
    return axios.get(`${state.baseApiURL}/member/totalsByVendor/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totalsByVendor', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totalsByVendor', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotalsByVendorByMonth({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonth', value: true });
    return axios.get(`${state.baseApiURL}/member/totalsByVendorByMonth/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totalsByVendorByMonth', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonth', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getTotalsByVendorByMonthOneRow({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonthOneRow', value: true });
    return axios.get(`${state.baseApiURL}/member/totalsByVendorByMonthOneRow/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        commit('SET_CONTENTS', { key: 'totalsByVendorByMonthOneRow', value: response.data });
        commit('TOGGLE_LOADING', { key: 'totalsByVendorByMonthOneRow', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },

  getStatsNational({ commit, state, getters }) {
    commit('TOGGLE_LOADING', { key: 'statsNational', value: true });
    return axios.get(`${state.baseApiURL}/member/statsNational/?${getters.apiFilterString}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        const computedStats = {
          ...response.data[0],
          physicians: lodash.chain(response.data).map('physicians').sumBy((stat) => parseFloat(stat)).value(),
          audiologists: lodash.chain(response.data).map('audiologists').sumBy((stat) => parseFloat(stat)).value(),
          avg_revenue: lodash.chain(response.data).map('avg_revenue').sumBy((stat) => parseFloat(stat)).value(),
          avg_units: lodash.chain(response.data).map('avg_units').sumBy((stat) => parseFloat(stat)).value(),
        };
        commit('SET_CONTENTS', {
          key: 'statsNational',
          value: {
            ...computedStats,
            revenue_per_audiologist: Math.round(computedStats.avg_revenue / (computedStats.audiologists || 1)),
            units_per_audiologist: Math.round(computedStats.avg_units / (computedStats.audiologists || 1)),
            asp: Math.round(computedStats.avg_revenue / (computedStats.avg_units || 1)),
          },
        });
        commit('TOGGLE_LOADING', { key: 'statsNational', value: false });
        commit('TOGGLE_LOADING', { key: 'sections', value: false });
      }).catch((thrown) => {});
  },
  downloadTransactions({ dispatch, getters }, payload) {
    // Modify filters to set content type to blob.
    // Turn on loading animation
    dispatch('main/setProperty', { key: 'globalLoading', value: true }, { root: true });

    return axios.get(`${state.baseApiURL}/member/transactions/csv/?${qs.stringify(payload, { arrayFormat: 'brackets' })}`, { cancelToken: getters.cancelToken.token })
      .then((response) => {
        dispatch('main/setProperty', { key: 'globalLoading', value: false }, { root: true });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data.csv');
        document.body.appendChild(link);
        link.click();
      }).catch((thrown) => {});
  },
  async cancelAjax({ dispatch }) {
    await dispatch('main/cancelAjax', null, { root: true });
    return;
  },
  resetStore({ commit, state, getters }) {
    commit('SET_PROPERTY', { key: 'contents', value: state.contentsTemplate });
  },
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },
  setContents({ commit }, payload) {
    commit('SET_CONTENTS', payload);
  },
  setFilter({ commit }, payload) {
    commit('SET_FILTER', payload);
  },
  setReport({ commit, state }, payload) {
    //selectedReport = this.reportsList.find( report => report.name == this.report );
    //{object: 'filters', key: 'flashReport', value: null}

    let selectedReport = state.filtersLists.reportsList.find( report => report.name == payload.value )
    let report = {object: 'filters', key: 'flashReport', value: selectedReport};
    commit('SET_FILTER', payload);
    commit('SET_FILTER', report);
    commit('SET_PROPERTY', { key: 'filtersChanged', value: true });
  }
};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    if (payload.key === 'dateFrom' || payload.key === 'dateTo') {
      state.filtersChanged = true;
    }
    state[payload.key] = payload.value;
  },
  SET_OBJECT_PROPERTY(state, payload) {
    state[payload.object][payload.key] = payload.value;
  },
  SET_CONTENTS(state, payload) {
    state.contents[payload.key] = payload.value;
  },
  SET_FILTER(state, payload) {
    if (state.initializers.initialLoad) {
      state.filtersChanged = true;
      state.contents = state.contentsTemplate;
    }
    state.filters[payload.key] = payload.value;
  },
  SET_FILTER_SIMPLE(state, payload) {
    state.filters[payload.key] = payload.value;
  },
  SET_FILTER_LIST(state, payload) {
    state.filtersLists[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
  TOGGLE_INITIALIZED(state, payload) {
    state.initializers[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
